import React, { useState } from "react";
import { StockCard } from "./StockCard";
import { AvailabilityDate } from "./AvailabilityDateCard";
import { StockStatusTag } from "./StockStatusTag";
import ArrivalsModal from "../arrivalsModal/ArrivalsModal";
import { buildProductImageUrl } from "../../api/stock";
import "../../css/App.css";

export default function ProductCard({ result }) {
  const hasArrivals = (result.AvailibilityList || []).length > 0;
  const imageUrl = buildProductImageUrl(result.ProductSku);
  const [imageFailed, setImageFailed] = useState(false);

  const showPlaceholder = !imageUrl || imageFailed;

  return (
    <article className="product-stock-card">
      <div className="product-card-main">
        <div
          className={`product-media${showPlaceholder ? " is-placeholder" : ""}`}
          aria-hidden={showPlaceholder}
        >
          {showPlaceholder ? (
            <span className="product-media-fallback" aria-hidden="true">
              <i className="fa fa-camera" />
            </span>
          ) : (
            <img
              src={imageUrl}
              alt=""
              loading="lazy"
              width={100}
              height={100}
              onError={() => setImageFailed(true)}
            />
          )}
        </div>
        <div className="product-body">
          <h2 className="search-card-title">{result.ProductSku}</h2>
          <div className="subtitle-tag">
            <StockStatusTag result={result} />
          </div>
          <div className="big-card-bottom">
            <StockCard result={result} />
            <AvailabilityDate result={result} />
          </div>
        </div>
      </div>
      {hasArrivals && (
        <div className="product-arrivals-action">
          <ArrivalsModal result={result} />
        </div>
      )}
    </article>
  );
}
